module.exports = __webpack_public_path__ + "static/media/btn-bg-salad.0008ec64.png";